import { Component, OnInit, Input } from "@angular/core";

@Component({
	selector: "app-action-button",
	templateUrl: "./action-button.component.html",
	styleUrls: ["./action-button.component.scss"]
})
export class ActionButtonComponent implements OnInit {
	@Input()
	action: () => Promise<any>;
	@Input()
	args: any[];
	@Input()
	context: any;
	@Input()
	processing: string;
	@Input()
	complete: string;
	@Input()
	btnClass: string;
	@Input()
	confirm: string;
	@Input()
	disabled: boolean;

	public pending = false;
	public success = false;
	public problem: string;

	ngOnInit() {
		if (!this.btnClass) {
			this.btnClass = "btn-success";
		}
	}

	async PerformAction() {
		this.problem = undefined;
		this.success = false;
		if (this.confirm) {
			if (!confirm(this.confirm)) {
				return;
			}
		}
		try {
			this.pending = true;
			await this.action.apply(this.context, this.args);
			this.success = true;
		} catch (err) {
			if (err.error && err.error.message) {
				this.problem = err.error.message;
			} else if (err.message) {
				this.problem = err.message;
			} else {
				this.problem = "Operation failed";
			}
			throw err;
		} finally {
			this.pending = false;
		}
	}

}
